__turbopack_context__.v({
  "caption": "templateTooltip-module-scss-module__nQDS8a__caption",
  "card": "templateTooltip-module-scss-module__nQDS8a__card",
  "currentCard": "templateTooltip-module-scss-module__nQDS8a__currentCard",
  "fill-until-next-card": "templateTooltip-module-scss-module__nQDS8a__fill-until-next-card",
  "preview": "templateTooltip-module-scss-module__nQDS8a__preview",
  "progress": "templateTooltip-module-scss-module__nQDS8a__progress",
  "progressTrack": "templateTooltip-module-scss-module__nQDS8a__progressTrack",
  "templateName": "templateTooltip-module-scss-module__nQDS8a__templateName",
});
